// extracted by css-extract-rspack-plugin
export default {"labelSwatch":"LabeledText-module__labelSwatch__iPZCM"};